interface Custom1TaskProps {
  task: OnboardingTask;
}

function Custom1Task({ task }: Custom1TaskProps) {
  return <div className="px-4"></div>;
}

export default Custom1Task;
